export default __webpack_public_path__ + "static/media/uploadcsv.c217e284.svg";